import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  CommonsCategoriesRequest,
  CommonsUsersRequest,
  CommonsUsersResponse
} from './types'
import { FilterListResponse } from '../../types'

const fetcher = new Fetcher({})

export const getCommonsUsers = async (role, data) =>
  fetcher.request<CommonsUsersRequest, CommonsUsersResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      API_DICTIONARY.COMMONS
    }${!!role ? role + '/' : ''}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getContractCategoriesList = async (role) =>
  fetcher.request<CommonsCategoriesRequest, FilterListResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      API_DICTIONARY.COMMONS
    }${role ? role + '/' : ''}${API_DICTIONARY.CONTRACT_CATEGORIES}`,
    method: HTTP_METHODS.GET
  })

export const getContractCategoriesForCommonsTable = async () =>
  fetcher.request<unknown, FilterListResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${API_DICTIONARY.COMMONS}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.CONTRACT_CATEGORIES}`,
    method: HTTP_METHODS.GET
  })
